<template>
    <el-dialog title="Filter jobs"
               :close-on-click-modal="false"
               :visible.sync="showForm"
               width="60%">

        <el-form label-position="top">
            <el-form-item label="Job ID (comma separated list)">
                <el-input v-model="formData.id"></el-input>
            </el-form-item>

            <el-form-item label="Job Title">
                <el-input v-model="formData.title"></el-input>
            </el-form-item>

            <el-form-item label="Job Nickname">
                <el-input v-model="formData.admin_description"></el-input>
            </el-form-item>

            <el-form-item label="Campaign">
                <el-select v-model="formData.campaign" clearable placeholder="Campaign" multiple style="width: 100%">
                    <el-option
                            v-for="(option) in filterOptions.campaignList"
                            :key="option.id"
                            :label="option.name"
                            :value="option.id">
                    </el-option>
                </el-select>
            </el-form-item>

            <div style="display: flex; flex-direction: row" class="dialog-category">
                <div class="mr-5">
                    <h6>Job Category</h6>
                    <label v-for="(value, key) in categories.driver" class="d-block">
                        <input type="checkbox" v-model="formData[key]"> {{ value }}
                    </label>
                </div>
                <div class="mr-5">
                    <h6>Equipment Type</h6>
                    <label v-for="(value, key) in categories.equipment" class="d-block">
                        <input type="checkbox" v-model="formData[key]"> {{ value }}
                    </label>
                </div>

                <div class="mr-5">
                    <h6>Driving Distance</h6>
                    <label v-for="(value, key) in categories.route" class="d-block">
                        <input type="checkbox" v-model="formData[key]"> {{ value }}
                    </label>
                </div>

                <div class="mr-5">
                    <h6>Teams</h6>
                    <label v-for="(value, key) in categories.teams" class="d-block">
                        <input type="checkbox" v-model="formData[key]"> {{ value }}
                    </label>
                </div>

                <div class="mr-5">
                    <h6>Specialization</h6>
                    <label v-for="(value, key) in categories.category" class="d-block">
                        <input type="checkbox" v-model="formData[key]"> {{ value }}
                    </label>
                </div>
            </div>

            <el-form-item label="State">
                <el-select v-model="formData.states" clearable multiple filterable placeholder="States"
                           style="width: 100%">
                    <el-option
                            v-for="(option) in filterOptions.stateList"
                            :key="option.id"
                            :label="option.name"
                            :value="option.id">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="Feed vs Manual">
                <el-select v-model="formData.feed" style="width: 100%">
                    <el-option v-for="option in filterOptions.feedOptions"
                               :key="`feed-${option.id}`"
                               :label="option.name"
                               :value="option.id"></el-option>
                </el-select>
            </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
            <el-button @click="showForm = false">Close</el-button>
            <el-button type="primary" @click="apply">Apply</el-button>
        </span>
    </el-dialog>
</template>

<script>
    export default {
        props: [
            'show',
            'data',
            'filterData',
            'filterOptions',
        ],
        data() {
            return {
                formData: {},
                categories: this.filterOptions.categories,
            };
        },
        watch: {
            filterData: {
                deep: true,
                handler() {
                    this.init();
                },
            },
        },
        computed: {
            showForm: {
                get() { return this.show; },
                set(val) { this.$emit('close'); },
            },
        },
        methods: {
            init() {
                this.formData = _.cloneDeep(this.filterData);
            },
            apply() {
                this.$emit('apply', { filters: this.formData });
                this.showForm = false;
            },
        },
        mounted() {
            this.init();
        },
    };
</script>

<style>
    .d-block {
        display: block;
    }

    .mr-5 {
        margin-right: 3rem !important;
    }

    .dialog-category label {
        font-weight: normal;
        cursor: pointer;
    }
</style>
